/* eslint-disable react/display-name,import/prefer-default-export */
import React from 'react';

/**
 * 图案填充最小重复单元
 */
const pattFillPathMap = {
    pct5: (fgClr, bgClr, scaleW, scaleH) => (<g transform={`scale(${1 / scaleW}, ${1 / scaleH})`}>
        <rect fill={bgClr} height="16" width="16"/>
        <circle cx="6" cy="6" r="1" fill={fgClr}/>
        <circle cx="14" cy="14" r="1" fill={fgClr}/></g>),
    pct10: (fgClr, bgClr, scaleW, scaleH) => (<g transform={`scale(${1 / scaleW}, ${1 / scaleH})`}>
        <rect fill={bgClr} height="7" width="13"/>
        <circle cx="1" cy="3" r="1" fill={fgClr}/>
        <circle cx="7" cy="1" r="1" fill={fgClr}/>
    </g>),
    pct20: (fgClr, bgClr, scaleW, scaleH) => (<g transform={`scale(${1 / scaleW}, ${1 / scaleH})`}>
        <rect fill={bgClr} height="8" width="8"/>
        <rect x="2" y="2" width="2" height="2" fill={fgClr}/>
        <rect x="6" y="6" width="2" height="2" fill={fgClr}/>
    </g>),
    pct25: (fgClr, bgClr, scaleW, scaleH) => (<g transform={`scale(${1 / scaleW}, ${1 / scaleH})`}>
        <rect fill={bgClr} height="4" width="8"/>
        <rect x="2" y="0" width="2" height="2" fill={fgClr}/>
        <rect x="6" y="2" width="2" height="2" fill={fgClr}/>
    </g>),
    pct30: (fgClr, bgClr, scaleW, scaleH) => (<g transform={`scale(${1 / scaleW}, ${1 / scaleH})`}>
        <rect fill={bgClr} height="16" width="16"/>
        <rect x="0" y="0" width="1" height="1" fill={fgClr}/>
        <rect x="15" y="0" width="1" height="1" fill={fgClr}/>
        <rect x="0" y="15" width="1" height="1" fill={fgClr}/>
        <rect x="15" y="15" width="1" height="1" fill={fgClr}/>
        <rect x="3" y="3" width="2" height="2" fill={fgClr}/>
        <rect x="11" y="3" width="2" height="2" fill={fgClr}/>
        <rect x="3" y="11" width="2" height="2" fill={fgClr}/>
        <rect x="11" y="11" width="2" height="2" fill={fgClr}/>
        <rect x="7" y="7" width="2" height="2" fill={fgClr}/>
        <line x1="0" y1="0" x2="16" y2="16" stroke={fgClr} strokeWidth="0.5" />
        <line x1="0" y1="16" x2="16" y2="0" stroke={fgClr} strokeWidth="0.5" />
    </g>),
    pct40: (fgClr, bgClr, scaleW, scaleH) => (<g transform={`scale(${1 / scaleW}, ${1 / scaleH})`}>
        <rect fill={fgClr} height="16" width="16"/>
        <rect x="2" y="0" width="2" height="2" fill={bgClr}/>
        <rect x="6" y="0" width="2" height="2" fill={bgClr}/>
        <rect x="10" y="0" width="2" height="2" fill={bgClr}/>
        <rect x="14" y="0" width="2" height="2" fill={bgClr}/>
        <rect x="0" y="2" width="2" height="2" fill={bgClr}/>
        <rect x="4" y="2" width="2" height="2" fill={bgClr}/>
        <rect x="8" y="2" width="2" height="2" fill={bgClr}/>
        <rect x="12" y="2" width="2" height="2" fill={bgClr}/>
        <rect x="2" y="4" width="2" height="2" fill={bgClr}/>
        <rect x="6" y="4" width="2" height="2" fill={bgClr}/>
        <rect x="10" y="4" width="2" height="2" fill={bgClr}/>
        <rect x="12" y="4" width="2" height="2" fill={bgClr}/>
        <rect x="14" y="4" width="2" height="2" fill={bgClr}/>
        <rect x="0" y="6" width="2" height="2" fill={bgClr}/>
        <rect x="4" y="6" width="2" height="2" fill={bgClr}/>
        <rect x="8" y="6" width="2" height="2" fill={bgClr}/>
        <rect x="12" y="6" width="2" height="2" fill={bgClr}/>
        <rect x="2" y="8" width="2" height="2" fill={bgClr}/>
        <rect x="6" y="8" width="2" height="2" fill={bgClr}/>
        <rect x="10" y="8" width="2" height="2" fill={bgClr}/>
        <rect x="14" y="8" width="2" height="2" fill={bgClr}/>
        <rect x="0" y="10" width="2" height="2" fill={bgClr}/>
        <rect x="4" y="10" width="2" height="2" fill={bgClr}/>
        <rect x="8" y="10" width="2" height="2" fill={bgClr}/>
        <rect x="12" y="10" width="2" height="2" fill={bgClr}/>
        <rect x="2" y="12" width="2" height="2" fill={bgClr}/>
        <rect x="4" y="12" width="2" height="2" fill={bgClr}/>
        <rect x="6" y="12" width="2" height="2" fill={bgClr}/>
        <rect x="10" y="12" width="2" height="2" fill={bgClr}/>
        <rect x="14" y="12" width="2" height="2" fill={bgClr}/>
        <rect x="0" y="14" width="2" height="2" fill={bgClr}/>
        <rect x="4" y="14" width="2" height="2" fill={bgClr}/>
        <rect x="8" y="14" width="2" height="2" fill={bgClr}/>
        <rect x="12" y="14" width="2" height="2" fill={bgClr}/>
    </g>),
    pct50: (fgClr, bgClr, scaleW, scaleH) => (<g transform={`scale(${1 / scaleW}, ${1 / scaleH})`}>
        <rect fill={fgClr} height="4" width="4"/>
        <rect x="0" y="0" width="2" height="2" fill={bgClr}/>
        <rect x="2" y="2" width="2" height="2" fill={bgClr}/>
    </g>),
    pct60: (fgClr, bgClr, scaleW, scaleH) => (<g transform={`scale(${1 / scaleW}, ${1 / scaleH})`}>
        <rect fill={fgClr} height="10" width="8"/>
        <rect x="2" y="0" width="2" height="2" fill={bgClr}/>
        <rect x="6" y="0" width="2" height="2" fill={bgClr}/>
        <rect x="4" y="2" width="2" height="2" fill={bgClr}/>
        <rect x="2" y="4" width="2" height="2" fill={bgClr}/>
        <rect x="6" y="4" width="2" height="2" fill={bgClr}/>
        <rect x="0" y="6" width="2" height="2" fill={bgClr}/>
    </g>),
    pct70: (fgClr, bgClr, scaleW, scaleH) => (<g transform={`scale(${1 / scaleW}, ${1 / scaleH})`}>
        <rect fill={fgClr} height="4" width="8"/>
        <rect x="2" y="0" width="2" height="2" fill={bgClr}/>
        <rect x="6" y="2" width="2" height="2" fill={bgClr}/>
    </g>),
    pct75: (fgClr, bgClr, scaleW, scaleH) => (<g transform={`scale(${1 / scaleW}, ${1 / scaleH})`}>
        <rect fill={fgClr} height="8" width="8"/>
        <rect x="2" y="2" width="2" height="2" fill={bgClr}/>
        <rect x="6" y="6" width="2" height="2" fill={bgClr}/>
    </g>),
    pct80: (fgClr, bgClr, scaleW, scaleH) => (<g transform={`scale(${1 / scaleW}, ${1 / scaleH})`}>
        <rect fill={fgClr} height="7" width="13"/>
        <circle cx="1" cy="3" r="1" fill={bgClr}/>
        <circle cx="7" cy="1" r="1" fill={bgClr}/>
    </g>),
    pct90: (fgClr, bgClr, scaleW, scaleH) => (<g transform={`scale(${1 / scaleW}, ${1 / scaleH})`}>
        <rect fill={fgClr} height="8" width="8"/>
        <circle cx="1" cy="4" r="1" fill={bgClr}/>
        <circle cx="5" cy="1" r="1" fill={bgClr}/>
    </g>),
    ltDnDiag: (fgClr, bgClr, scaleW, scaleH) => (<g transform={`scale(${1 / scaleW}, ${1 / scaleH})`}>
        <rect fill={bgClr} height="10" width="10"/>
        <rect x="1" y="0" width="2" height="1" fill={fgClr}/>
        <rect x="3" y="1" width="2" height="2" fill={fgClr}/>
        <rect x="5" y="3" width="2" height="2" fill={fgClr}/>
        <rect x="7" y="5" width="2" height="2" fill={fgClr}/>
        <rect x="9" y="7" width="1" height="2" fill={fgClr}/>
        <rect x="0" y="7" width="1" height="2" fill={fgClr}/>
        <rect x="1" y="9" width="2" height="1" fill={fgClr}/>
    </g>),
    ltUpDiag: (fgClr, bgClr, scaleW, scaleH) => (<g transform={`scale(${1 / scaleW}, ${1 / scaleH})`}>
        <rect fill={bgClr} height="10" width="10"/>
        <rect x="7" y="0" width="2" height="1" fill={fgClr}/>
        <rect x="5" y="1" width="2" height="2" fill={fgClr}/>
        <rect x="3" y="3" width="2" height="2" fill={fgClr}/>
        <rect x="1" y="5" width="2" height="2" fill={fgClr}/>
        <rect x="0" y="7" width="1" height="2" fill={fgClr}/>
        <rect x="9" y="7" width="1" height="2" fill={fgClr}/>
        <rect x="7" y="9" width="2" height="1" fill={fgClr}/>
    </g>),
    dkDnDiag: (fgClr, bgClr, scaleW, scaleH) => (<g transform={`scale(${1 / scaleW}, ${1 / scaleH})`}>
        <rect fill={bgClr} height="10" width="10"/>
        <rect x="0" y="0" width="4" height="1" fill={fgClr}/>
        <rect x="2" y="1" width="4" height="2" fill={fgClr}/>
        <rect x="4" y="3" width="4" height="2" fill={fgClr}/>
        <rect x="6" y="5" width="4" height="2" fill={fgClr}/>
        <rect x="8" y="7" width="2" height="2" fill={fgClr}/>
        <rect x="0" y="7" width="2" height="2" fill={fgClr}/>
        <rect x="0" y="9" width="4" height="1" fill={fgClr}/>
    </g>),
    dkUpDiag: (fgClr, bgClr, scaleW, scaleH) => (<g transform={`scale(${1 / scaleW}, ${1 / scaleH})`}>
        <rect fill={bgClr} height="10" width="10"/>
        <rect x="6" y="0" width="4" height="1" fill={fgClr}/>
        <rect x="4" y="1" width="4" height="2" fill={fgClr}/>
        <rect x="2" y="3" width="4" height="2" fill={fgClr}/>
        <rect x="0" y="5" width="4" height="2" fill={fgClr}/>
        <rect x="0" y="7" width="2" height="2" fill={fgClr}/>
        <rect x="8" y="7" width="2" height="2" fill={fgClr}/>
        <rect x="6" y="9" width="4" height="1" fill={fgClr}/>
    </g>),
    wdDnDiag: (fgClr, bgClr, scaleW, scaleH) => (<g transform={`scale(${1 / scaleW}, ${1 / scaleH})`}>
        <rect fill={bgClr} height="10" width="10"/>
        <rect x="0" y="0" width="2" height="1" fill={fgClr}/>
        <rect x="1" y="0" width="2" height="2" fill={fgClr}/>
        <rect x="2" y="1" width="2" height="2" fill={fgClr}/>
        <rect x="3" y="2" width="2" height="2" fill={fgClr}/>
        <rect x="4" y="3" width="2" height="2" fill={fgClr}/>
        <rect x="5" y="4" width="2" height="2" fill={fgClr}/>
        <rect x="6" y="5" width="2" height="2" fill={fgClr}/>
        <rect x="7" y="6" width="2" height="2" fill={fgClr}/>
        <rect x="8" y="7" width="2" height="2" fill={fgClr}/>
        <rect x="9" y="8" width="1" height="2" fill={fgClr}/>
        <rect x="0" y="8" width="1" height="2" fill={fgClr}/>
        <rect x="0" y="9" width="2" height="1" fill={fgClr}/>
    </g>),
    wdUpDiag: (fgClr, bgClr, scaleW, scaleH) => (<g transform={`scale(${1 / scaleW}, ${1 / scaleH})`}>
        <rect fill={bgClr} height="10" width="10"/>
        <rect x="8" y="0" width="2" height="1" fill={fgClr}/>
        <rect x="7" y="0" width="2" height="2" fill={fgClr}/>
        <rect x="6" y="1" width="2" height="2" fill={fgClr}/>
        <rect x="5" y="2" width="2" height="2" fill={fgClr}/>
        <rect x="4" y="3" width="2" height="2" fill={fgClr}/>
        <rect x="3" y="4" width="2" height="2" fill={fgClr}/>
        <rect x="2" y="5" width="2" height="2" fill={fgClr}/>
        <rect x="1" y="6" width="2" height="2" fill={fgClr}/>
        <rect x="0" y="7" width="2" height="2" fill={fgClr}/>
        <rect x="0" y="8" width="1" height="2" fill={fgClr}/>
        <rect x="9" y="8" width="1" height="2" fill={fgClr}/>
        <rect x="8" y="9" width="2" height="1" fill={fgClr}/>
    </g>),
    ltVert: (fgClr, bgClr, scaleW, scaleH) => (<g transform={`scale(${1 / scaleW}, ${1 / scaleH})`}>
        <rect fill={bgClr} height="10" width="5"/>
        <line stroke={fgClr} y2="10" x2="5" y1="0" x1="5" strokeWidth="1"/>
    </g>),
    ltHorz: (fgClr, bgClr, scaleW, scaleH) => (<g transform={`scale(${1 / scaleW}, ${1 / scaleH})`}>
        <rect fill={bgClr} height="5" width="10"/>
        <line stroke={fgClr} y2="5" x2="10" y1="5" x1="0" strokeWidth="1" />
    </g>),
    narVert: (fgClr, bgClr, scaleW, scaleH) => (<g transform={`scale(${1 / scaleW}, ${1 / scaleH})`}>
        <rect fill={bgClr} height="8" width="8"/>
        <line stroke={fgClr} y2="8" x2="4" y1="0" x1="4" strokeWidth="1"/>
    </g>),
    narHorz: (fgClr, bgClr, scaleW, scaleH) => (<g transform={`scale(${1 / scaleW}, ${1 / scaleH})`}>
        <rect fill={bgClr} height="8" width="8"/>
        <line stroke={fgClr} y2="10" x2="4" y1="0" x1="4" strokeWidth="1"/>
    </g>),
    dkVert: (fgClr, bgClr, scaleW, scaleH) => (<g transform={`scale(${1 / scaleW}, ${1 / scaleH})`}>
        <rect fill={bgClr} height="10" width="5"/>
        <line stroke={fgClr} y2="10" x2="0" y1="0" x1="0" strokeWidth="2"/>
    </g>),
    dkHorz: (fgClr, bgClr, scaleW, scaleH) => (<g transform={`scale(${1 / scaleW}, ${1 / scaleH})`}>
        <rect fill={bgClr} height="5" width="10"/>
        <line stroke={fgClr} y2="0" x2="10" y1="0" x1="0" strokeWidth="2"/>
    </g>),
    dashDnDiag: (fgClr, bgClr, scaleW, scaleH) => (<g transform={`scale(${1 / scaleW}, ${1 / scaleH})`}>
        <rect fill={bgClr} height="26" width="16"/>
        <rect x="0" y="16" width="4" height="4" fill={fgClr}/>
        <rect x="4" y="18" width="4" height="4" fill={fgClr}/>
        <rect x="8" y="20" width="4" height="4" fill={fgClr}/>
        <rect x="12" y="22" width="4" height="4" fill={fgClr}/>
    </g>),
    dashUpDiag: (fgClr, bgClr, scaleW, scaleH) => (<g transform={`scale(${1 / scaleW}, ${1 / scaleH})`}>
        <rect fill={bgClr} height="26" width="16"/>
        <rect x="0" y="22" width="4" height="4" fill={fgClr}/>
        <rect x="4" y="20" width="4" height="4" fill={fgClr}/>
        <rect x="8" y="18" width="4" height="4" fill={fgClr}/>
        <rect x="12" y="16" width="4" height="4" fill={fgClr}/>
    </g>),
    dashHorz: (fgClr, bgClr, scaleW, scaleH) => (<g transform={`scale(${1 / scaleW}, ${1 / scaleH})`}>
        <rect fill={bgClr} height="20" width="10"/>
        <rect x="0" y="18" width="5" height="2" fill={fgClr}/>
        <rect x="5" y="8" width="5" height="2" fill={fgClr}/>
    </g>),
    dashVert: (fgClr, bgClr, scaleW, scaleH) => (<g transform={`scale(${1 / scaleW}, ${1 / scaleH})`}>
        <rect fill={bgClr} height="20" width="10"/>
        <rect x="0" y="10" width="2" height="10" fill={fgClr}/>
        <rect x="8" y="0" width="2" height="10" fill={fgClr}/>
    </g>),
    smConfetti: (fgClr, bgClr, scaleW, scaleH) => (<g transform={`scale(${1 / scaleW}, ${1 / scaleH})`}>
        <rect fill={bgClr} height="16" width="16"/>
        <rect x="0" y="14" width="2" height="2" fill={fgClr}/>
        <rect x="2" y="10" width="2" height="2" fill={fgClr}/>
        <rect x="4" y="2" width="2" height="2" fill={fgClr}/>
        <rect x="6" y="6" width="2" height="2" fill={fgClr}/>
        <rect x="8" y="12" width="2" height="2" fill={fgClr}/>
        <rect x="10" y="0" width="2" height="2" fill={fgClr}/>
        <rect x="12" y="8" width="2" height="2" fill={fgClr}/>
        <rect x="14" y="4" width="2" height="2" fill={fgClr}/>
    </g>),
    lgConfetti: (fgClr, bgClr, scaleW, scaleH) => (<g transform={`scale(${1 / scaleW}, ${1 / scaleH})`}>
        <rect fill={bgClr} height="16" width="16"/>
        <rect x="2" y="2" width="4" height="4" fill={fgClr}/>
        <rect x="0" y="12" width="4" height="4" fill={fgClr}/>
        <rect x="4" y="8" width="4" height="4" fill={fgClr}/>
        <rect x="8" y="0" width="4" height="4" fill={fgClr}/>
        <rect x="12" y="4" width="4" height="4" fill={fgClr}/>
        <rect x="10" y="10" width="4" height="4" fill={fgClr}/>
    </g>),
    zigZag: (fgClr, bgClr, scaleW, scaleH) => (<g transform={`scale(${1 / scaleW}, ${1 / scaleH})`}>
        <rect fill={bgClr} height="8" width="16"/>
        <rect x="2" y="4" width="2" height="2" fill={fgClr}/>
        <rect x="4" y="2" width="2" height="2" fill={fgClr}/>
        <rect x="6" y="0" width="4" height="2" fill={fgClr}/>
        <rect x="10" y="2" width="2" height="2" fill={fgClr}/>
        <rect x="12" y="4" width="2" height="2" fill={fgClr}/>
        <rect x="14" y="6" width="2" height="2" fill={fgClr}/>
    </g>),
    wave: (fgClr, bgClr, scaleW, scaleH) => (<g transform={`scale(${1 / scaleW}, ${1 / scaleH})`}>
        <rect fill={bgClr} height="6" width="16"/>
        <rect x="0" y="0" width="2" height="2" fill={fgClr}/>
        <rect x="2" y="2" width="2" height="2" fill={fgClr}/>
        <rect x="6" y="2" width="2" height="2" fill={fgClr}/>
        <rect x="8" y="4" width="2" height="2" fill={fgClr}/>
        <rect x="12" y="2" width="2" height="2" fill={fgClr}/>
        <rect x="14" y="0" width="2" height="2" fill={fgClr}/>
    </g>),
    diagBrick: (fgClr, bgClr, scaleW, scaleH) => (<g transform={`scale(${1 / scaleW}, ${1 / scaleH})`}>
        <rect fill={bgClr} height="16" width="16"/>
        <rect x="0" y="12" width="2" height="2" fill={fgClr}/>
        <rect x="2" y="10" width="2" height="2" fill={fgClr}/>
        <rect x="4" y="8" width="4" height="2" fill={fgClr}/>
        <rect x="6" y="6" width="2" height="2" fill={fgClr}/>
        <rect x="8" y="4" width="2" height="2" fill={fgClr}/>
        <rect x="10" y="2" width="2" height="2" fill={fgClr}/>
        <rect x="12" y="0" width="2" height="2" fill={fgClr}/>
        <rect x="8" y="10" width="2" height="2" fill={fgClr}/>
        <rect x="10" y="12" width="2" height="2" fill={fgClr}/>
        <rect x="12" y="14" width="2" height="2" fill={fgClr}/>
    </g>),
    horzBrick: (fgClr, bgClr, scaleW, scaleH) => (<g transform={`scale(${1 / scaleW}, ${1 / scaleH})`}>
        <rect fill={bgClr} height="16" width="16"/>
        <rect x="7" y="0" width="2" height="6" fill={fgClr}/>
        <rect x="0" y="6" width="16" height="2" fill={fgClr}/>
        <rect x="0" y="8" width="2" height="6" fill={fgClr}/>
        <rect x="0" y="14" width="16" height="2" fill={fgClr}/>
    </g>),
    weave: (fgClr, bgClr, scaleW, scaleH) => (<g transform={`scale(${1 / scaleW}, ${1 / scaleH})`}>
        <rect fill={bgClr} height="16" width="16"/>
        <rect fill={fgClr} x="3" y="0" width="2" height="1"/>
        <rect fill={fgClr} x="5" y="1" width="2" height="2"/>
        <rect fill={fgClr} x="11" y="0" width="2" height="1"/>
        <rect fill={fgClr} x="9" y="1" width="2" height="2"/>
        <rect fill={fgClr} x="13" y="1" width="2" height="2"/>
        <rect fill={fgClr} x="0" y="3" width="1" height="2"/>
        <rect fill={fgClr} x="7" y="3" width="2" height="2"/>
        <rect fill={fgClr} x="15" y="3" width="1" height="2"/>
        <rect fill={fgClr} x="1" y="5" width="2" height="2"/>
        <rect fill={fgClr} x="5" y="5" width="2" height="2"/>
        <rect fill={fgClr} x="13" y="5" width="2" height="2"/>
        <rect fill={fgClr} x="3" y="7" width="2" height="2"/>
        <rect fill={fgClr} x="11" y="7" width="2" height="2"/>
        <rect fill={fgClr} x="0" y="11" width="1" height="2"/>
        <rect fill={fgClr} x="5" y="1" width="2" height="2"/>
        <rect fill={fgClr} x="9" y="9" width="2" height="2"/>
        <rect fill={fgClr} x="13" y="9" width="2" height="2"/>
        <rect fill={fgClr} x="13" y="9" width="2" height="2"/>
        <rect fill={fgClr} x="7" y="11" width="2" height="2"/>
        <rect fill={fgClr} x="15" y="11" width="1" height="2"/>
        <rect fill={fgClr} x="1" y="13" width="2" height="2"/>
        <rect fill={fgClr} x="5" y="13" width="2" height="2"/>
        <rect fill={fgClr} x="9" y="13" width="2" height="2"/>
        <rect fill={fgClr} x="3" y="15" width="2" height="1"/>
        <rect fill={fgClr} x="11" y="15" width="2" height="1"/>
    </g>),
    plaid: (fgClr, bgClr, scaleW, scaleH) => (<g transform={`scale(${1 / scaleW}, ${1 / scaleH})`}>
        <rect fill={bgClr} height="16" width="16"/>
        <rect x="8" y="0" width="8" height="8" fill={fgClr}/>
        <rect x="0" y="8" width="2" height="2" fill={fgClr}/>
        <rect x="4" y="8" width="2" height="2" fill={fgClr}/>
        <rect x="8" y="8" width="2" height="2" fill={fgClr}/>
        <rect x="12" y="8" width="2" height="2" fill={fgClr}/>
        <rect x="2" y="10" width="2" height="2" fill={fgClr}/>
        <rect x="6" y="10" width="2" height="2" fill={fgClr}/>
        <rect x="10" y="10" width="2" height="2" fill={fgClr}/>
        <rect x="14" y="10" width="2" height="2" fill={fgClr}/>
        <rect x="0" y="12" width="2" height="2" fill={fgClr}/>
        <rect x="4" y="12" width="2" height="2" fill={fgClr}/>
        <rect x="8" y="12" width="2" height="2" fill={fgClr}/>
        <rect x="12" y="12" width="2" height="2" fill={fgClr}/>
        <rect x="2" y="14" width="2" height="2" fill={fgClr}/>
        <rect x="6" y="14" width="2" height="2" fill={fgClr}/>
        <rect x="10" y="14" width="2" height="2" fill={fgClr}/>
        <rect x="14" y="14" width="2" height="2" fill={fgClr}/>
    </g>),
    divot: (fgClr, bgClr, scaleW, scaleH) => (<g transform={`scale(${1 / scaleW}, ${1 / scaleH})`}>
        <rect fill={bgClr} height="16" width="16"/>
        <rect x="2" y="0" width="2" height="2" fill={fgClr}/>
        <rect x="0" y="2" width="2" height="2" fill={fgClr}/>
        <rect x="2" y="4" width="2" height="2" fill={fgClr}/>
        <rect x="12" y="10" width="2" height="2" fill={fgClr}/>
        <rect x="14" y="12" width="2" height="2" fill={fgClr}/>
        <rect x="12" y="14" width="2" height="2" fill={fgClr}/>
    </g>),
    dotGrid: (fgClr, bgClr, scaleW, scaleH) => (<g transform={`scale(${1 / scaleW}, ${1 / scaleH})`}>
        <rect fill={bgClr} height="16" width="16"/>
        <rect x="0" y="0" width="2" height="2" fill={fgClr}/>
        <rect x="4" y="0" width="2" height="2" fill={fgClr}/>
        <rect x="8" y="0" width="2" height="2" fill={fgClr}/>
        <rect x="12" y="0" width="2" height="2" fill={fgClr}/>
        <rect x="0" y="4" width="2" height="2" fill={fgClr}/>
        <rect x="0" y="8" width="2" height="2" fill={fgClr}/>
        <rect x="0" y="12" width="2" height="2" fill={fgClr}/>
    </g>),
    dotDmnd: (fgClr, bgClr, scaleW, scaleH) => (<g transform={`scale(${1 / scaleW}, ${1 / scaleH})`}>
        <rect fill={bgClr} height="16" width="16"/>
        <rect x="0" y="0" width="2" height="2" fill={fgClr}/>
        <rect x="4" y="4" width="2" height="2" fill={fgClr}/>
        <rect x="8" y="8" width="2" height="2" fill={fgClr}/>
        <rect x="12" y="4" width="2" height="2" fill={fgClr}/>
        <rect x="4" y="12" width="2" height="2" fill={fgClr}/>
        <rect x="12" y="12" width="2" height="2" fill={fgClr}/>
    </g>),
    shingle: (fgClr, bgClr, scaleW, scaleH) => (<g transform={`scale(${1 / scaleW}, ${1 / scaleH})`}>
        <rect fill={bgClr} height="16" width="16"/>
        <rect x="0" y="4" width="4" height="2" fill={fgClr}/>
        <rect x="4" y="2" width="2" height="2" fill={fgClr}/>
        <rect x="6" y="4" width="2" height="4" fill={fgClr}/>
        <rect x="4" y="8" width="4" height="2" fill={fgClr}/>
        <rect x="0" y="12" width="2" height="2" fill={fgClr}/>
        <rect x="2" y="10" width="2" height="2" fill={fgClr}/>
        <rect x="8" y="10" width="2" height="2" fill={fgClr}/>
        <rect x="10" y="12" width="2" height="2" fill={fgClr}/>
        <rect x="12" y="14" width="4" height="2" fill={fgClr}/>
    </g>),
    trellis: (fgClr, bgClr, scaleW, scaleH) => (<g transform={`scale(${1 / scaleW}, ${1 / scaleH})`}>
        <rect fill={bgClr} height="16" width="16"/>
        <rect x="0" y="0" width="8" height="11" fill={fgClr}/>
        <rect x="8" y="5" width="8" height="11" fill={fgClr}/>
    </g>),
    sphere: (fgClr, bgClr, scaleW, scaleH) => (<g transform={`scale(${1 / scaleW}, ${1 / scaleH})`}>
        <rect fill={bgClr} height="16" width="16"/>
        <rect fill={fgClr} x="1" y="0" width="7" height="1"/>
        <rect fill={fgClr} x="9" y="0" width="7" height="1"/>
        <rect fill={fgClr} x="4" y="1" width="4" height="2"/>
        <rect fill={fgClr} x="0" y="1" width="1" height="7"/>
        <rect fill={fgClr} x="8" y="1" width="1" height="7"/>
        <rect fill={fgClr} x="1" y="3" width="7" height="6"/>
        <rect fill={fgClr} x="0" y="9" width="1" height="7"/>
        <rect fill={fgClr} x="8" y="9" width="1" height="7"/>
        <rect fill={fgClr} x="9" y="8" width="7" height="1"/>
        <rect fill={fgClr} x="12" y="9" width="4" height="2"/>
        <rect fill={fgClr} x="9" y="11" width="7" height="6"/>
    </g>),
    smGrid: (fgClr, bgClr, scaleW, scaleH) => (<g transform={`scale(${1 / scaleW}, ${1 / scaleH})`}>
        <rect fill={bgClr} height="8" width="8"/>
        <rect fill={fgClr} x="0" y="0" width="8" height="2"/>
        <rect fill={fgClr} x="0" y="2" width="2" height="6"/>
    </g>),
    lgGrid: (fgClr, bgClr, scaleW, scaleH) => (<g transform={`scale(${1 / scaleW}, ${1 / scaleH})`}>
        <rect fill={bgClr} height="16" width="16"/>
        <rect fill={fgClr} x="0" y="0" width="16" height="2"/>
        <rect fill={fgClr} x="0" y="2" width="2" height="14"/>
    </g>),
    smCheck: (fgClr, bgClr, scaleW, scaleH) => (<g transform={`scale(${1 / scaleW}, ${1 / scaleH})`}>
        <rect fill={bgClr} height="8" width="8"/>
        <rect fill={fgClr} x="0" y="0" width="4" height="4"/>
        <rect fill={fgClr} x="4" y="4" width="4" height="4"/>
    </g>),
    lgCheck: (fgClr, bgClr, scaleW, scaleH) => (<g transform={`scale(${1 / scaleW}, ${1 / scaleH})`}>
        <rect fill={bgClr} height="16" width="16"/>
        <rect fill={fgClr} x="0" y="0" width="8" height="8"/>
        <rect fill={fgClr} x="8" y="8" width="8" height="8"/>
    </g>),
    openDmnd: (fgClr, bgClr, scaleW, scaleH) => (<g transform={`scale(${1 / scaleW}, ${1 / scaleH})`}>
        <rect fill={bgClr} height="16" width="16"/>
        <rect fill={fgClr} x="0" y="0" width="1" height="1"/>
        <rect fill={fgClr} x="15" y="0" width="1" height="1"/>
        <rect fill={fgClr} x="0" y="15" width="1" height="1"/>
        <rect fill={fgClr} x="15" y="15" width="1" height="1"/>
        <rect fill={fgClr} x="1" y="1" width="2" height="2"/>
        <rect fill={fgClr} x="3" y="3" width="2" height="2"/>
        <rect fill={fgClr} x="5" y="5" width="2" height="2"/>
        <rect fill={fgClr} x="7" y="7" width="2" height="2"/>
        <rect fill={fgClr} x="9" y="5" width="2" height="2"/>
        <rect fill={fgClr} x="11" y="3" width="2" height="2"/>
        <rect fill={fgClr} x="13" y="1" width="2" height="2"/>
        <rect fill={fgClr} x="5" y="9" width="2" height="2"/>
        <rect fill={fgClr} x="3" y="11" width="2" height="2"/>
        <rect fill={fgClr} x="1" y="13" width="2" height="2"/>
        <rect fill={fgClr} x="9" y="9" width="2" height="2"/>
        <rect fill={fgClr} x="11" y="11" width="2" height="2"/>
        <rect fill={fgClr} x="13" y="13" width="2" height="2"/>
    </g>),
    solidDmnd: (fgClr, bgClr, scaleW, scaleH) => (<g transform={`scale(${1 / scaleW}, ${1 / scaleH})`}>
        <rect fill={bgClr} height="16" width="16"/>
        <rect fill={fgClr} x="7" y="1" width="2" height="2"/>
        <rect fill={fgClr} x="5" y="3" width="6" height="2"/>
        <rect fill={fgClr} x="3" y="5" width="10" height="2"/>
        <rect fill={fgClr} x="1" y="7" width="14" height="2"/>
        <rect fill={fgClr} x="3" y="9" width="10" height="2"/>
        <rect fill={fgClr} x="5" y="11" width="6" height="2"/>
        <rect fill={fgClr} x="7" y="13" width="2" height="2"/>
    </g>),
};

/**
 * 根据preset获取最小重复单元svg
 * @param preset preset
 * @param fgClr 前景色
 * @param bgClr 背景色
 * @param scaleW
 * @param scaleH
 */
export function getPattFillPathFromPrst(preset: string, fgClr, bgClr, scaleW, scaleH) {
    if (pattFillPathMap[preset]) {
        return pattFillPathMap[preset](fgClr?.color?.srgb_color, bgClr?.color?.srgb_color, scaleW, scaleH);
    }
    return pattFillPathMap.pct5(fgClr?.color?.srgb_color, bgClr?.color?.srgb_color, scaleW, scaleH); // default
}
